<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ticketSessionPage',
})
</script>
<template>
  <div class="ticket-session-page">
    <a-spin :spinning="state.loading.config">
      <a-card :bordered="false">
        <!-- 展览日期 -->
        <div class="date-section">
          <span class="section-label required">展览日期</span>
          <ant-picker v-model:value="state.dateForm.dateRange" value-format="YYYY-MM-DD"
            :disabled="isTicketPublished ? [true, false] : [false, false]" :disabled-date="disabledEndDate"
            @change="onDateRangeChange" />
          <!-- 测试模式切换（临时） -->
          <!-- <div class="test-mode-wrap" v-if="isTicketPublished">
            <span class="test-mode-label">未延长时原范围外</span>
            <a-radio-group v-model:value="enablePreExtendEdit">
              <a-radio :value="false">不可编辑</a-radio>
              <a-radio :value="true">可编辑</a-radio>
            </a-radio-group>
          </div> -->
        </div>

        <!-- 日历 -->
        <div class="calendar-wrapper">
          <div class="calendar-header">
            <a-button type="text" class="month-nav" @click="prevMonth">
              <LeftOutlined />
            </a-button>
            <span class="calendar-title">{{ currentMonthText }}</span>
            <a-button type="text" class="month-nav" @click="nextMonth">
              <RightOutlined />
            </a-button>
            <a-button type="text" class="today-btn" @click="goToday">今天</a-button>
          </div>
          <div class="calendar-body">
            <div class="calendar-weekday" v-for="day in weekDays" :key="day">{{ day }}</div>
            <div v-for="cell in calendarCells" :key="cell.date" class="calendar-cell" :class="cell.cellClass"
              @click="onSelectDate(cell)">
              <div class="cell-content">
                <span class="cell-date">{{ cell.day }}</span>
                <span class="cell-lunar" v-if="cell.lunar">{{ cell.lunar }}</span>
                <span class="cell-today-tag" v-if="cell.isToday">今天</span>
              </div>
              <div class="cell-session-info" v-if="cell.sessionInfo">
                <div class="session-time-slot">{{ cell.sessionInfo.timeSlotName }}</div>
                <div class="session-count">{{ cell.sessionInfo.count }}个场次</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 编辑场次 -->
        <div class="day-session-editor" v-if="state.selectedDate">
          <div class="editor-header">
            <div class="editor-title">编辑场次</div>
            <div class="editor-date">
              <ClockCircleOutlined class="editor-date-icon" />
              <div class="editor-date-text">{{ state.selectedDate }}</div>
            </div>
          </div>
          <a-spin :spinning="state.loading.daySession">
            <div class="session-list">
              <div v-for="(session, index) in state.daySessions" :key="index" class="session-row"
                :class="{ 'session-disabled': session.enabled === 0 || !isEditorEditable(state.selectedDate) }">
                <a-select v-model:value="session.timeSlotCode" placeholder="请选择场次" class="session-select"
                  :disabled="!isEditorEditable(state.selectedDate)"
                  @change="(val: string) => onDayTimeSlotChange(index, val)">
                  <a-select-option v-for="slot in availableDayTimeSlots(index)" :key="slot.code" :value="slot.code">{{
                    slot.label }}</a-select-option>
                </a-select>
                <div class="session-time">
                  <span class="label">时效</span>
                  <div class="session-time-picker">
                    <a-time-picker v-model:value="session.startTime" value-format="HH:mm" format="HH:mm"
                      placeholder="开始" class="session-time-start" :disabled="!isEditorEditable(state.selectedDate)"
                      :disabled-hours="() => disabledStartHours(index)"
                      :disabled-minutes="(h: number) => disabledStartMinutes(index, h)" :show-now="false"
                      popup-class-name="ticket-time-picker-popup"
                      @openChange="(open: boolean) => onTimePickerOpen(open, index, 'start')"
                      @change="(t: any) => onStartTimeChange(index, t)" />
                    <span class="time-separator">-</span>
                    <a-time-picker v-model:value="session.endTime" value-format="HH:mm" format="HH:mm" placeholder="结束"
                      class="session-time-end" :disabled="!isEditorEditable(state.selectedDate)"
                      :disabled-hours="() => disabledEndHours(index, session.startTime)"
                      :disabled-minutes="(h: number) => disabledEndMinutes(index, session.startTime, h)"
                      :show-now="false" popup-class-name="ticket-time-picker-popup"
                      @openChange="(open: boolean) => onEndPickerOpenChange(open, index)"
                      @change="(t: any) => onEndTimeChange(index, t)" />
                  </div>
                </div>
                <div class="session-price">
                  <span class="label">票价</span>
                  <div class="price-input-wrap">
                    <span class="price-symbol">￥</span>
                    <div class="session-price-input">
                      <a-input v-model:value="session.priceText" placeholder="请输入票价" :maxlength="11"
                        :disabled="!isEditorEditable(state.selectedDate)" allow-clear
                        @input="(e: Event) => handlePriceInput(index, e)"
                        @compositionend="(e: Event) => handlePriceInput(index, e)"
                        @blur="() => handlePriceBlur(index)" />
                    </div>
                  </div>
                </div>
                <a-button type="primary" shape="circle" class="session-delete-btn"
                  :disabled="!isEditorEditable(state.selectedDate)" @click="removeDaySession(index)">
                  <CloseOutlined />
                </a-button>
              </div>
              <a-button type="link" @click="addDaySession"
                :disabled="state.daySessions.length >= 10 || !isEditorEditable(state.selectedDate)"
                class="add-session-btn">
                <PlusOutlined />新增场次
              </a-button>
            </div>
          </a-spin>
        </div>

        <div class="detail-footer">
          <a-button class="detail-close-btn" @click="onCancel">取 消</a-button>
          <a-button v-if="!isTicketPublished" class="detail-confirm-btn" @click="onSaveDay"
            :loading="state.loading.saveDay">保存草稿</a-button>
          <a-button class="detail-publish-btn" type="primary" @click="onPublishDay"
            :loading="state.loading.publishDay">发布门票</a-button>
        </div>
      </a-card>
    </a-spin>
  </div>
</template>

<script setup lang="ts" name="ticketSessionPage">
import { reactive, ref, computed, onMounted, h, nextTick, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { message, Modal } from 'ant-design-vue'
import { LeftOutlined, RightOutlined, PlusOutlined, ExclamationCircleOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons-vue'
import { cloneDeep } from 'lodash-es'
import { useTicket, type TicketSession, type TimeSlotOption } from '@/store/ticket/ticket'
import { getLunarDateStr } from '@/utils/lunar'
import dayjs from 'dayjs'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isBetween from 'dayjs/plugin/isBetween'

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)
dayjs.extend(isBetween)

const route = useRoute()
const router = useRouter()
const ticketStore = useTicket()

const ticketId = computed(() => {
  const id = route.params.id
  return id ? String(id) : ''
})

const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']

const currentMonth = ref(dayjs())
const state = reactive({
  loading: {
    config: false,
    daySession: false,
    saveDay: false,
    publishDay: false
  },
  publishStatus: 0 as number | undefined,
  config: {
    ticketId: 0,
    exhibitionName: '',
    startDate: '',
    endDate: '',
    originalEndDate: '',
    startDateEditable: false,
    defaultSessions: [] as TicketSession[]
  },
  dateForm: {
    dateRange: [] as string[]
  },
  selectedDate: '',
  daySessions: [] as TicketSession[],
  dayEditable: true,
  monthSessions: {} as Record<string, TicketSession[]>
})

const timeSlotOptions = ref<TimeSlotOption[]>([])

const isTicketPublished = computed(() => {
  return state.publishStatus === 1
})

const currentMonthText = computed(() => {
  return `${currentMonth.value.year()}年${currentMonth.value.month() + 1}月`
})

const isDateEditable = computed(() => {
  if (!state.config.startDate) return true
  return true
})

const isDateLocked = computed(() => {
  return !isDateEditable.value
})

const disabledEndDate = (current: any) => {
  // 草稿状态：不限制开始/结束日期的选择
  if (!isTicketPublished.value) return false
  // 已发布状态：结束日期不能早于原结束日期，不能早于开始日期，跨度不超过1年
  if (!state.config.startDate) return false
  const start = dayjs(state.config.startDate).startOf('day')
  const currentDate = dayjs(current).startOf('day')
  if (state.config.originalEndDate) {
    const originalEnd = dayjs(state.config.originalEndDate).startOf('day')
    if (currentDate.isBefore(originalEnd, 'day')) return true
  }
  if (currentDate.isBefore(start, 'day')) return true
  return currentDate.diff(start, 'days') > 365
}

const calendarCells = computed(() => {
  const startOfMonth = currentMonth.value.startOf('month')
  const endOfMonth = currentMonth.value.endOf('month')
  const startDay = startOfMonth.day()
  const daysInMonth = endOfMonth.date()
  const cells: any[] = []

  // empty placeholders so 1st aligns to correct weekday column
  for (let i = 0; i < startDay; i++) {
    cells.push({ date: `empty-${i}`, day: '', type: 'empty', inRange: false, cellClass: 'empty' })
  }

  // current month only
  for (let d = 1; d <= daysInMonth; d++) {
    const date = startOfMonth.add(d - 1, 'day')
    cells.push(makeCell(date, 'current'))
  }

  return cells
})

const makeCell = (date: dayjs.Dayjs, type: string) => {
  const dateStr = date.format('YYYY-MM-DD')
  const start = state.config.startDate ? dayjs(state.config.startDate) : null
  const end = state.config.endDate ? dayjs(state.config.endDate) : null
  const inRange = start && end ? (date.isSameOrAfter(start, 'day') && date.isSameOrBefore(end, 'day')) : false
  const isSelected = state.selectedDate === dateStr
  const isToday = date.isSame(dayjs(), 'day')
  const locked = isLockedDate(dateStr)
  const editable = isEditorEditable(dateStr)
  const sessions = state.monthSessions[dateStr]                                                       
  const hasSession = sessions?.length > 0
  const canClick = true
  const sessionInfo = hasSession
    ? {
      timeSlotName: sessions.map((s: any) => s.timeSlotName).join(' '),
      count: sessions.length
    }
    : null
  return {
    date: dateStr,
    day: date.date(),
    lunar: getLunarDateStr(dateStr), // 农历
    type,
    sessionInfo,
    inRange,
    isSelected,
    isToday,
    locked,
    editable,
    hasSession,
    canClick,
    cellClass: [
      type,
      isSelected ? 'selected' : '',
      isToday ? 'today' : '',
      locked ? 'locked-date' : '',
      inRange ? 'in-range' : 'not-in-range',
      !editable ? 'not-editable' : '',
      hasSession ? 'has-session' : 'no-session'
    ].filter(Boolean).join(' ')
  }
}

const formatTime = (time?: string) => {
  if (!time || typeof time !== 'string') return '--:--'
  return time
}

const availableDayTimeSlots = (currentIndex: number) => {
  const selectedCodes = state.daySessions
    .map((s, i) => (i === currentIndex ? null : s.timeSlotCode))
    .filter(Boolean) as string[]
  return timeSlotOptions.value.filter((slot) => !selectedCodes.includes(slot.code))
}

const parseTimeObj = (time?: string): string => {
  if (!time) return ''
  if (typeof time === 'string') return time
  return ''
}

const handlePriceInput = (index: number, e: Event) => {
  const target = e.target as HTMLInputElement
  let val = target.value
  // 过滤非数字和非小数点
  val = val.replace(/[^\d.]/g, '')
  // 最多保留一个小数点
  const firstDot = val.indexOf('.')
  if (firstDot !== -1) {
    val = val.substring(0, firstDot + 1) + val.substring(firstDot + 1).replace(/\./g, '')
  }
  // 整数部分最多8位，小数部分最多2位
  if (firstDot !== -1) {
    const intPart = val.substring(0, firstDot).slice(0, 8)
    const decPart = val.substring(firstDot + 1).slice(0, 2)
    val = intPart + '.' + decPart
  } else {
    val = val.slice(0, 8)
  }
  target.value = val
  const session = state.daySessions[index]
  session.priceText = val
  session.price = val ? parseFloat(val) : undefined
  syncDaySessionsToCache()
}

const handlePriceBlur = (index: number) => {
  const session = state.daySessions[index]
  const price = session.price
  if (price === undefined || price === null || Number.isNaN(price) || price <= 0) {
    session.priceText = ''
    session.price = undefined
  }
  syncDaySessionsToCache()
}

const compareTime = (a?: string, b?: string): number => {
  return parseTimeObj(a).localeCompare(parseTimeObj(b))
}

const isTimeBefore = (a?: string, b?: string): boolean => {
  return compareTime(a, b) < 0
}

const isTimeAfter = (a?: string, b?: string): boolean => {
  return compareTime(a, b) > 0
}

const parseHourMinute = (time?: string): [number, number] => {
  if (!time) return [-1, -1]
  const str = typeof time === 'string' ? time : dayjs(time).format('HH:mm')
  const parts = str.split(':')
  const h = parseInt(parts[0] || '', 10)
  const m = parseInt(parts[1] || '', 10)
  return [isNaN(h) ? -1 : h, isNaN(m) ? -1 : m]
}

const timeToMinutes = (time?: string): number => {
  const [h, m] = parseHourMinute(time)
  if (h < 0 || m < 0) return -1
  return h * 60 + m
}

const addOneMinute = (time?: string): string => {
  const [h, m] = parseHourMinute(time)
  if (h < 0 || m < 0) return ''
  let newH = h
  let newM = m + 1
  if (newM >= 60) {
    newM = 0
    newH = newH + 1
  }
  if (newH >= 24) return '23:59'
  return `${String(newH).padStart(2, '0')}:${String(newM).padStart(2, '0')}`
}

// 前面所有已填行中，取每行 endTime || startTime 的最大值，再加 1 分钟作为当前行下限
const getLowerBound = (sessions: TicketSession[], index: number): string => {
  let max = -1
  let bound = ''
  for (let i = 0; i < index; i++) {
    const s = sessions[i]
    const t = s.endTime || s.startTime
    const mins = timeToMinutes(t)
    if (mins > max) {
      max = mins
      bound = t
    }
  }
  return bound ? addOneMinute(bound) : ''
}

// 后面所有已填行中，取每行 startTime || endTime 的最小值作为当前行上限
const getUpperBound = (sessions: TicketSession[], index: number): string => {
  let min = Number.MAX_SAFE_INTEGER
  let bound = ''
  for (let i = index + 1; i < sessions.length; i++) {
    const s = sessions[i]
    const t = s.startTime || s.endTime
    const mins = timeToMinutes(t)
    if (mins >= 0 && mins < min) {
      min = mins
      bound = t
    }
  }
  return bound
}

const disabledStartHours = (index: number) => {
  return []
}

const disabledStartMinutes = (index: number, selectedHour?: number) => {
  return []
}

const disabledEndHours = (index: number, startTime?: string) => {
  const disabled: number[] = []
  if (startTime) {
    const [startHour] = parseHourMinute(startTime)
    for (let i = 0; i < startHour; i++) disabled.push(i)
  }
  return disabled
}

const disabledEndMinutes = (index: number, startTime?: string, selectedHour?: number) => {
  if (selectedHour === undefined || selectedHour < 0) return []
  const disabled: number[] = []
  if (startTime) {
    const [startHour, startMinute] = parseHourMinute(startTime)
    if (selectedHour === startHour) {
      for (let i = 0; i <= startMinute; i++) disabled.push(i)
    }
  }
  return disabled
}

const isValidTime = (timeStr?: string): boolean => {
  if (!timeStr || typeof timeStr !== 'string') return false
  const [hourStr, minuteStr] = timeStr.split(':')
  const hour = parseInt(hourStr || '', 10)
  const minute = parseInt(minuteStr || '', 10)
  return !isNaN(hour) && !isNaN(minute) && hour >= 0 && hour <= 23 && minute >= 0 && minute <= 59
}

const findFirstAvailableHour = (disabledHours: number[]): number => {
  for (let h = 0; h < 24; h++) {
    if (!disabledHours.includes(h)) return h
  }
  return 0
}

const findFirstAvailableMinute = (disabledMinutes: number[]): number => {
  for (let m = 0; m < 60; m++) {
    if (!disabledMinutes.includes(m)) return m
  }
  return 0
}

const isTimeDisabled = (type: 'start' | 'end', index: number, timeStr: string, startTime?: string): boolean => {
  const [h, m] = parseHourMinute(timeStr)
  if (h < 0 || m < 0) return true
  if (type === 'start') {
    return false
  }
  return disabledEndHours(index, startTime).includes(h) || disabledEndMinutes(index, startTime, h).includes(m)
}

const findFirstAvailableTime = (type: 'start' | 'end', index: number, startTime?: string): string | null => {
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m++) {
      const timeStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
      if (!isTimeDisabled(type, index, timeStr, startTime)) {
        return timeStr
      }
    }
  }
  return null
}

const getDefaultOpenValue = (index: number, type: 'start' | 'end'): dayjs.Dayjs | null => {
  const session = state.daySessions[index]
  const now = dayjs()
  const currentHour = now.hour()
  const currentMinute = now.minute()
  const startTime = type === 'end' ? session.startTime : undefined

  const currentValue = type === 'start' ? session.startTime : session.endTime
  if (currentValue && isValidTime(currentValue) && !isTimeDisabled(type, index, currentValue, startTime)) {
    const [h, m] = currentValue.split(':').map(Number)
    return dayjs().hour(h).minute(m).second(0)
  }

  if (type === 'end' && session.startTime && isValidTime(session.startTime)) {
    const [startHour, startMinute] = session.startTime.split(':').map(Number)
    let h = startHour
    let m = startMinute + 1
    if (m >= 60) {
      m = 0
      h = h + 1
    }
    for (; h < 24; h++) {
      for (; m < 60; m++) {
        const timeStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
        if (!isTimeDisabled(type, index, timeStr, startTime)) {
          return dayjs().hour(h).minute(m).second(0)
        }
      }
      m = 0
    }
  }

  let h = currentHour
  let m = currentMinute
  for (; h < 24; h++) {
    for (; m < 60; m++) {
      const timeStr = `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`
      if (!isTimeDisabled(type, index, timeStr, startTime)) {
        return dayjs().hour(h).minute(m).second(0)
      }
    }
    m = 0
  }

  const fallback = findFirstAvailableTime(type, index, startTime)
  if (!fallback) return null
  const [fh, fm] = fallback.split(':').map(Number)
  return dayjs().hour(fh).minute(fm).second(0)
}

const onTimePickerOpen = (open: boolean, index: number, type: 'start' | 'end') => {
  if (!open) return
  const session = state.daySessions[index]
  const target = getDefaultOpenValue(index, type)
  if (!target) return
  const targetStr = target.format('HH:mm')
  if (type === 'start' && !session.startTime) {
    session.startTime = targetStr
  }
  if (type === 'end' && !session.endTime) {
    session.endTime = targetStr
  }
  const targetHour = target.hour()
  nextTick(() => {
    const panels = document.querySelectorAll('.ticket-time-picker-popup .ant-picker-time-panel-column')
    if (panels.length === 0) return
    const hourPanel = panels[0] as HTMLElement
    const rowHeight = 28
    hourPanel.scrollTop = targetHour * rowHeight
  })
}

const onEndPickerOpenChange = (open: boolean, index: number) => {
  if (open) {
    onTimePickerOpen(true, index, 'end')
  }
}

const syncDaySessionsToCache = () => {
  if (state.selectedDate) {
    state.monthSessions[state.selectedDate] = cloneDeep(state.daySessions)
  }
}

const onStartTimeChange = (index: number, val: any) => {
  if (!val) return
  const time = typeof val === 'string' ? val : dayjs(val).format('HH:mm')
  state.daySessions[index].startTime = time
  syncDaySessionsToCache()
}

const onEndTimeChange = (index: number, val: any) => {
  const session = state.daySessions[index]
  const timeStr = val ? (typeof val === 'string' ? val : dayjs(val).format('HH:mm')) : ''
  session.endTime = timeStr
  syncDaySessionsToCache()
}

const onDayTimeSlotChange = (index: number, code: string) => {
  const slot = timeSlotOptions.value.find((s) => s.code === code)
  const session = state.daySessions[index]
  if (slot && session) {
    session.startTime = slot.startTime
    session.endTime = slot.endTime
    session.timeSlotCode = slot.code
    session.timeSlotName = slot.label
    syncDaySessionsToCache()
  }
}

const addDaySession = () => {
  if (state.daySessions.length >= 10) {
    message.warning('最多添加10个场次')
    return
  }
  state.daySessions.push({
    timeSlotCode: undefined,
    startTime: '',
    endTime: '',
    price: undefined,
    priceText: '',
    enabled: 1,
    sortOrder: state.daySessions.length
  })
  syncDaySessionsToCache()
}

const removeDaySession = (index: number) => {
  state.daySessions.splice(index, 1)
  syncDaySessionsToCache()
}

const loadTimeSlots = async () => {
  try {
    const data: any = await ticketStore.getDict({ code: 'ticket_session' })
    timeSlotOptions.value = (data || []).map((item: any) => ({
      code: item.code,
      label: item.name,
      startTime: item.startTime,
      endTime: item.endTime
    }))
  } catch (e) {
    timeSlotOptions.value = []
  }
}

const loadConfig = async () => {
  if (!ticketId.value) {
    message.error('缺少门票ID')
    router.push({ name: 'ticket' })
    return
  }
  state.loading.config = true
  // 初始化时清空缓存，避免旧数据影响日期范围判断
  state.monthSessions = {}
  try {
    const data: any = await ticketStore.getTicketInfo(ticketId.value)
    if (data) {
      state.publishStatus = data.publishStatus
      state.config = {
        ...state.config,
        ticketId: data.id,
        exhibitionName: data.exhibitionName || '',
        startDate: data.startDate || '',
        endDate: data.endDate || '',
        originalEndDate: data.endDate || '',
        startDateEditable: false,
        defaultSessions: (data.sessions || []).map((s: TicketSession, i: number) => ({ ...s, sortOrder: i }))
      }
      state.dateForm.dateRange = [data.startDate, data.endDate]
      await loadMonthSessions()
    }
  } finally {
    state.loading.config = false
  }
}

const getEffectiveStartDate = () => {
  if (!state.config.startDate) return dayjs().startOf('day')
  return dayjs(state.config.startDate).isAfter(dayjs(), 'day')
    ? dayjs(state.config.startDate).startOf('day')
    : dayjs().startOf('day')
}

// 是否允许在延长日期前提前编辑原日期范围外的日期（测试模式开关）
const enablePreExtendEdit = ref(false)

const isEditorEditable = (date: string) => {
  const targetDate = dayjs(date).startOf('day')
  const today = dayjs().startOf('day')
  // 1. 今天之前的日期，不管在不在展览日期范围内都禁掉
  if (targetDate.isBefore(today, 'day')) return false
  // 草稿状态：今天及之后的日期都可以编辑场次
  if (!isTicketPublished.value) return true

  const startDate = state.config.startDate ? dayjs(state.config.startDate).startOf('day') : null
  const endDate = state.config.endDate ? dayjs(state.config.endDate).startOf('day') : null
  const originalEndDate = state.config.originalEndDate ? dayjs(state.config.originalEndDate).startOf('day') : null

  // 2. 日期小于开始日期，都不可以编辑
  if (!startDate || targetDate.isBefore(startDate, 'day')) return false

  // 3. 不在原展览日期范围内的日期
  if (originalEndDate && targetDate.isAfter(originalEndDate, 'day')) {
    if (enablePreExtendEdit.value) return true
    // 只有真正发生延长后，才允许编辑延长区间内的日期
    if (!endDate || !endDate.isAfter(originalEndDate, 'day')) return false
    if (targetDate.isAfter(endDate, 'day')) return false
    return true
  }

  // 4. 在展览原日期范围内的，受 T+16 限制（包含今天共16天锁定，第17天开始可编辑）
  const lockDate = today.add(15, 'day').startOf('day')
  return targetDate.isAfter(lockDate, 'day')
}

const isLockedDate = (date: string) => {
  const targetDate = dayjs(date).startOf('day')
  const today = dayjs().startOf('day')
  // 今天之前的日期锁定
  if (targetDate.isBefore(today, 'day')) return true
  if (!isTicketPublished.value) return false

  const startDate = state.config.startDate ? dayjs(state.config.startDate).startOf('day') : null
  const endDate = state.config.endDate ? dayjs(state.config.endDate).startOf('day') : null
  const originalEndDate = state.config.originalEndDate ? dayjs(state.config.originalEndDate).startOf('day') : null

  // 小于开始日期锁定
  if (!startDate || targetDate.isBefore(startDate, 'day')) return true

  // 不在原展览日期范围内的日期
  if (originalEndDate && targetDate.isAfter(originalEndDate, 'day')) {
    if (enablePreExtendEdit.value) return false
    // 未发生延长前锁定；已延长但超出当前结束日期的也锁定
    if (!endDate || !endDate.isAfter(originalEndDate, 'day')) return true
    return targetDate.isAfter(endDate, 'day')
  }

  // 在原展览日期范围内：T+16 及之前锁定（包含今天共16天锁定）
  const lockDate = today.add(15, 'day').startOf('day')
  return !targetDate.isAfter(lockDate, 'day')
}

const isExtendedDate = (date: string) => {
  const targetDate = dayjs(date).startOf('day')
  const startDate = state.config.startDate ? dayjs(state.config.startDate).startOf('day') : null
  const endDate = state.config.endDate ? dayjs(state.config.endDate).startOf('day') : null
  const originalEndDate = state.config.originalEndDate ? dayjs(state.config.originalEndDate).startOf('day') : null

  // 没有原结束日期，说明不是从已发布状态延期来的
  if (!startDate || !endDate || !originalEndDate) return false

  // 必须在当前展览日期范围内
  if (targetDate.isBefore(startDate, 'day') || targetDate.isAfter(endDate, 'day')) return false

  // 开启提前编辑模式时，不严格依赖是否已发生延长
  if (enablePreExtendEdit.value) {
    return targetDate.isAfter(originalEndDate, 'day')
  }

  // 只有真正发生过延期（当前结束日期 > 原结束日期），且日期在延期区间内
  if (!endDate.isAfter(originalEndDate, 'day')) return false

  return targetDate.isAfter(originalEndDate, 'day')
}

// 延长日期时，给新增日期生成默认场次模板
// 默认模板统一取自 ticket/info 返回的 sessions 配置
const getDefaultSessionTemplate = () => {
  // defaultSessions 来自 ticket/info 的 sessions 字段，是门票的默认场次配置模板
  const template = state.config.defaultSessions
  if (!template.length) return []
  return template.map((s: TicketSession, i: number) => ({
    ...s,
    id: undefined,            // 新场次需要后端生成 id，清空原模板 id
    startTime: parseTimeObj(s.startTime),
    endTime: parseTimeObj(s.endTime),
    priceText: s.price !== undefined && s.price !== null ? String(s.price) : '',
    sortOrder: i              // 重新按顺序编号，避免多日期 sortOrder 冲突
  }))
}

const loadMonthSessions = async (mergeLocal = false) => {
  if (!state.config.startDate || !state.config.endDate) return
  state.loading.config = true
  try {
    const data: any = await ticketStore.getTicketSessionList(ticketId.value)
    const sessions = data?.sessions || []
    const monthSessions: Record<string, TicketSession[]> = {}
    sessions.forEach((item: any) => {
      const date = item.sessionDate
      if (!date) return
      if (!monthSessions[date]) monthSessions[date] = []
      monthSessions[date].push({
        ...item,
        startTime: parseTimeObj(item.startTime),
        endTime: parseTimeObj(item.endTime),
        priceText: item.price !== undefined && item.price !== null ? String(item.price) : ''
      })
    })

    // 延长展览日期时，保留本地已经编辑过的场次缓存，避免用户之前添加的场次被覆盖
    if (mergeLocal) {
      Object.keys(state.monthSessions).forEach((date) => {
        // 只保留在当前展览日期范围内、且后台没有最新数据的日期
        const d = dayjs(date).startOf('day')
        const start = dayjs(state.config.startDate).startOf('day')
        const end = dayjs(state.config.endDate).startOf('day')
        if (d.isBefore(start, 'day') || d.isAfter(end, 'day')) return
        if (!monthSessions[date]) {
          monthSessions[date] = cloneDeep(state.monthSessions[date])
        }
      })
    }

    state.monthSessions = monthSessions
    // 默认模板从 ticket/info 的 sessions 字段获取，不要覆盖
    // loadConfig 中已经初始化 defaultSessions，这里不再用 ticketSession/list 里原结束日期当天的场次覆盖
  } catch (e) {
    console.error('加载场次数据失败', e)
  } finally {
    state.loading.config = false
  }
}

const loadDaySessions = async (date: string) => {
  state.loading.daySession = true
  try {
    const hasCached = Object.prototype.hasOwnProperty.call(state.monthSessions, date)
    const cached = state.monthSessions[date]
    if (hasCached) {
      state.dayEditable = isEditorEditable(date)
      state.daySessions = (cached || []).map((s: TicketSession, i: number) => ({
        ...s,
        startTime: parseTimeObj(s.startTime),
        endTime: parseTimeObj(s.endTime),
        priceText: s.price !== undefined && s.price !== null ? String(s.price) : '',
        sortOrder: i
      }))
      return
    }

    // 新范围内日期直接显示空表单，不调接口
    if (isEditorEditable(date)) {
      state.dayEditable = true
      state.daySessions = []
      return
    }

    // 不在新范围内但可能有场次的日期，展示不可编辑
    state.dayEditable = false
    state.daySessions = []
  } finally {
    state.loading.daySession = false
  }
}

const onSelectDate = (cell: any) => {
  state.selectedDate = cell.date
  loadDaySessions(cell.date)
}

// 实时同步当前编辑日期的场次到 monthSessions，让上方 calendar cell 即时刷新
// 注：现在由用户主动操作方法中调用 syncDaySessionsToCache 同步，避免系统自动加载空表单时写入空缓存
// watch(
//   () => state.daySessions,
//   () => {
//     if (state.selectedDate) {
//       state.monthSessions[state.selectedDate] = getDaySessions()
//     }
//   },
//   { deep: true }
// )

const onDateRangeChange = async (val: string[]) => {
  if (!val || val.length < 2 || !val[1]) {
    state.config.endDate = ''
    return
  }
  const start = dayjs(val[0])
  const end = dayjs(val[1])
  if (end.diff(start, 'days') > 365) {
    message.error('展览日期跨度不能超过1年')
    state.dateForm.dateRange = [state.config.startDate, state.config.endDate]
    return
  }
  // 已发布状态：结束日期不能早于原结束日期
  if (isTicketPublished.value) {
    const originalEnd = state.config.originalEndDate ? dayjs(state.config.originalEndDate).startOf('day') : null
    if (originalEnd && end.startOf('day').isBefore(originalEnd, 'day')) {
      message.error('结束日期不能早于原结束日期')
      state.dateForm.dateRange = [state.config.startDate, state.config.endDate]
      return
    }
  }

  const oldEndDate = state.config.endDate ? dayjs(state.config.endDate).startOf('day') : null
  const newEndDate = end.startOf('day')

  // 本地更新开始/结束日期
  state.config.startDate = val[0]
  state.config.endDate = val[1]

  // 结束日期变长时，已发布状态下预先把今天及之后的延期日期默认场次写入缓存
  if (isTicketPublished.value && oldEndDate && newEndDate.isAfter(oldEndDate, 'day')) {
    const originalEndDate = state.config.originalEndDate ? dayjs(state.config.originalEndDate).startOf('day') : null
    const today = dayjs().startOf('day')
    let selectedDateFilled = false
    if (originalEndDate) {
      let d = originalEndDate.add(1, 'day')
      while (d.isSameOrBefore(newEndDate, 'day')) {
        const dateStr = d.format('YYYY-MM-DD')
        if (d.isSameOrAfter(today, 'day') && !Object.prototype.hasOwnProperty.call(state.monthSessions, dateStr)) {
          state.monthSessions[dateStr] = cloneDeep(getDefaultSessionTemplate())
          if (dateStr === state.selectedDate) {
            selectedDateFilled = true
          }
        }
        d = d.add(1, 'day')
      }
    }
    // 如果当前正在编辑的日期被填充了默认模板，刷新右侧编辑区
    if (selectedDateFilled && state.selectedDate) {
      loadDaySessions(state.selectedDate)
    }
  }

  refreshDefaultSessions()
}

const refreshDefaultSessions = () => {
  // 默认模板从 ticket/info 的 sessions 字段获取，不根据缓存动态刷新
  // loadConfig 已初始化 defaultSessions，这里不做覆盖
}

const validateDaySessions = () => {
  // 允许某天没有场次
  if (!state.daySessions.length) {
    return true
  }
  const dateText = state.selectedDate ? `${state.selectedDate} ` : ''
  for (const session of state.daySessions) {
    if (!session.timeSlotCode) {
      message.error(`${dateText}请选择场次`)
      return false
    }
    if (!session.startTime || !session.endTime) {
      message.error(`${dateText}请填写时效`)
      return false
    }
    if (!isTimeAfter(session.endTime, session.startTime)) {
      message.error(`${dateText}结束时间必须晚于开始时间`)
      return false
    }
    if (session.price === undefined || session.price === null || session.price <= 0) {
      message.error(`${dateText}请输入有效的票价`)
      return false
    }
  }
  return true
}

const buildSessionPayload = (s: any, i: number) => ({
  timeSlotCode: s.timeSlotCode,
  startTime: parseTimeObj(s.startTime),
  endTime: parseTimeObj(s.endTime),
  price: s.price,
  enabled: s.enabled,
  sortOrder: i
})

const isValidSession = (s: TicketSession): boolean => {
  return !!(s.timeSlotCode && s.startTime && s.endTime)
}

const isCompleteSession = (s: TicketSession): boolean => {
  return !!(s.timeSlotCode && s.startTime && s.endTime) && s.price !== undefined && s.price !== null && s.price >= 0
}

const isPartialSession = (s: TicketSession): boolean => {
  const hasPrice = s.price !== undefined && s.price !== null
  const hasAny = !!(s.timeSlotCode || s.startTime || s.endTime || hasPrice)
  return hasAny && !isCompleteSession(s)
}

const validateAllSessionsInRange = () => {
  const startStr = state.config.startDate || state.dateForm.dateRange[0]
  const endStr = state.config.endDate
  if (!startStr || !endStr) return { valid: true, firstInvalidDate: '' }
  const start = dayjs(startStr).startOf('day')
  const end = dayjs(endStr).endOf('day')
  const sortedDates = Object.keys(state.monthSessions)
    .filter((dateStr) => {
      const date = dayjs(dateStr).startOf('day')
      return date.isSameOrAfter(start, 'day') && date.isSameOrBefore(end, 'day')
    })
    .sort()
  for (const dateStr of sortedDates) {
    const daySessions = state.monthSessions[dateStr] || []
    if (!daySessions.length) continue
    const allComplete = daySessions.every(isCompleteSession)
    if (!allComplete) {
      return { valid: false, firstInvalidDate: dateStr }
    }
  }
  return { valid: true, firstInvalidDate: '' }
}

const buildPublishParams = (flag: string) => {
  const sessions: any[] = []
  const startStr = state.config.startDate || state.dateForm.dateRange[0]
  const endStr = state.config.endDate
  if (!startStr || !endStr) {
    return {
      ticketId: ticketId.value,
      startDate: startStr,
      endDate: endStr,
      flag,
      sessions
    }
  }
  const start = dayjs(startStr).startOf('day')
  const end = dayjs(endStr).endOf('day')
  // 复制一份临时数据，过滤掉不在展览日期范围内的场次后提交
  const tempMonthSessions = cloneDeep(state.monthSessions)
  Object.keys(tempMonthSessions).forEach((dateStr) => {
    const date = dayjs(dateStr).startOf('day')
    if (date.isBefore(start, 'day') || date.isAfter(end, 'day')) {
      delete tempMonthSessions[dateStr]
    }
  })
  const startDateObj = dayjs(startStr)
  const endDateObj = dayjs(endStr)
  const days = endDateObj.diff(startDateObj, 'days') + 1
  for (let i = 0; i < days; i++) {
    const date = startDateObj.add(i, 'day').format('YYYY-MM-DD')
    const daySessions = tempMonthSessions[date] || []
    const validSessions = daySessions.filter(isValidSession).map((s, idx) => ({
      sessionDate: date,
      timeSlotCode: s.timeSlotCode,
      startTime: parseTimeObj(s.startTime),
      endTime: parseTimeObj(s.endTime),
      price: s.price,
      enabled: s.enabled,
      sortOrder: idx
    }))
    if (!validSessions.length) continue
    sessions.push(...validSessions)
  }
  return {
    ticketId: ticketId.value,
    startDate: startStr,
    endDate: endStr,
    flag,
    sessions
  }
}

const clearSessionsOutOfRange = () => {
  const startStr = state.config.startDate || state.dateForm.dateRange[0]
  const endStr = state.config.endDate
  if (!startStr || !endStr) return
  const start = dayjs(startStr).startOf('day')
  const end = dayjs(endStr).endOf('day')
  Object.keys(state.monthSessions).forEach((dateStr) => {
    const date = dayjs(dateStr).startOf('day')
    if (date.isBefore(start, 'day') || date.isAfter(end, 'day')) {
      delete state.monthSessions[dateStr]
    }
  })
}

const hasSessionsOutOfRange = () => {
  const startStr = state.config.startDate || state.dateForm.dateRange[0]
  const endStr = state.config.endDate
  if (!startStr || !endStr) return false
  const start = dayjs(startStr).startOf('day')
  const end = dayjs(endStr).endOf('day')
  return Object.keys(state.monthSessions).some((dateStr) => {
    const date = dayjs(dateStr).startOf('day')
    return state.monthSessions[dateStr]?.length > 0 && (date.isBefore(start, 'day') || date.isAfter(end, 'day'))
  })
}

const doSaveDay = () => {
  state.loading.saveDay = true
  ticketStore.publishDaySessions(buildPublishParams('0')).then(() => {
    loadMonthSessions()
    message.success('保存成功')
    router.push({ name: 'ticket' })
  }).finally(() => {
    state.loading.saveDay = false
  })
}

const getDaySessions = () => {
  return cloneDeep(state.daySessions)
}

const onSaveDay = () => {
  if (!state.config.endDate) {
    message.error('请选择结束日期')
    return
  }
  // 保存草稿时：当前日期保留所有已添加的场次条目（包括空行），用于后续校验
  if (state.selectedDate) {
    state.monthSessions[state.selectedDate] = getDaySessions()
  }
  const { valid, firstInvalidDate } = validateAllSessionsInRange()
  if (!valid) {
    message.error(`${firstInvalidDate} 的场次信息填写不完整，请补充场次、时效和票价`)
    return
  }
  if (hasSessionsOutOfRange()) {
    Modal.confirm({
      transitionName: '',
      title: '提示',
      icon: () => h(ExclamationCircleOutlined),
      centered: true,
      content: '系统将自动清空不在当前展览日期范围内的场次配置，是否继续操作？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        doSaveDay()
      }
    })
    return
  }
  doSaveDay()
}

const doPublishDay = () => {
  state.loading.publishDay = true
  return ticketStore.publishDaySessions(buildPublishParams('1')).then(() => {
    loadMonthSessions()
    message.success('发布成功')
    router.push({ name: 'ticket' })
  }).finally(() => {
    state.loading.publishDay = false
  })
}

const onPublishDay = () => {
  if (!state.config.endDate) {
    message.error('请选择结束日期')
    return
  }
  // 发布时：当前日期保留所有已添加的场次条目（包括空行），用于后续校验
  if (state.selectedDate) {
    state.monthSessions[state.selectedDate] = getDaySessions()
  }
  // 校验当前选中日期
  if (state.selectedDate && state.daySessions.some((s) => isValidSession(s))) {
    if (!validateDaySessions()) return
  }
  const { valid, firstInvalidDate } = validateAllSessionsInRange()
  if (!valid) {
    message.error(`${firstInvalidDate} 的场次信息填写不完整，请补充场次、时效和票价`)
    return
  }
  if (hasSessionsOutOfRange()) {
    Modal.confirm({
      transitionName: '',
      title: '提示',
      icon: () => h(ExclamationCircleOutlined),
      centered: true,
      content: '系统将自动清空不在当前展览日期范围内的场次配置，是否继续操作？',
      okText: '确认',
      cancelText: '取消',
      onOk: () => {
        return doPublishDay()
      }
    })
    return
  }
  Modal.confirm({
    transitionName: '',
    title: '提示',
    icon: () => h(ExclamationCircleOutlined),
    centered: true,
    content: '发布后场次的票价将对用户可见，是否确认发布？',
    okText: '确认',
    cancelText: '取消',
    onOk: () => {
      return doPublishDay()
    }
  })
}

const onCancel = () => {
  router.push({ name: 'ticket' })
}

const prevMonth = () => {
  currentMonth.value = currentMonth.value.subtract(1, 'month')
}

const nextMonth = () => {
  currentMonth.value = currentMonth.value.add(1, 'month')
}

const goToday = () => {
  currentMonth.value = dayjs()
  const today = dayjs().format('YYYY-MM-DD')
  const start = state.config.startDate ? dayjs(state.config.startDate) : null
  const end = state.config.endDate ? dayjs(state.config.endDate) : null
  if (start && end && dayjs(today).isBetween(start, end, 'day', '[]')) {
    state.selectedDate = today
    loadDaySessions(today)
  }
}

onMounted(() => {
  loadTimeSlots()
  loadConfig().then(() => {
    const effectiveStart = getEffectiveStartDate()
    const endDate = state.config.endDate ? dayjs(state.config.endDate).endOf('day') : effectiveStart.add(1, 'year')
    let target = effectiveStart
    // 自动选中第一个可编辑日期
    while (target.isBefore(endDate) || target.isSame(endDate, 'day')) {
      if (isEditorEditable(target.format('YYYY-MM-DD'))) {
        currentMonth.value = target
        state.selectedDate = target.format('YYYY-MM-DD')
        loadDaySessions(state.selectedDate)
        return
      }
      target = target.add(1, 'day')
    }
    // 没有可编辑日期时，默认选中第一个在范围内且可点击的日期（用于展示）
    target = effectiveStart
    while (target.isBefore(endDate) || target.isSame(endDate, 'day')) {
      const cell = makeCell(target, 'current')
      if (cell.inRange && cell.canClick) {
        currentMonth.value = target
        state.selectedDate = target.format('YYYY-MM-DD')
        loadDaySessions(state.selectedDate)
        return
      }
      target = target.add(1, 'day')
    }
    // 若因展览已结束等原因没有可选日期，回退到今天，保证页面有选中态
    const fallbackDate = dayjs().format('YYYY-MM-DD')
    currentMonth.value = dayjs(fallbackDate)
    state.selectedDate = fallbackDate
    loadDaySessions(state.selectedDate)
  })
})
</script>

<style scoped lang="less">
@import '@/style/index.less';

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

:deep(.ant-picker:not(:hover):not(.ant-picker-focused)) {
  border-color: #C5C5D3;
}

:deep(.ant-input-number:not(:hover):not(.ant-input-number-focused)) {
  border-color: #C5C5D3;
}

.ticket-session-page {
  :deep(.ant-card) {
    border-radius: 0;
  }

  :deep(.ant-card-body) {
    padding: 0;
  }

  .date-section {
    display: flex;
    align-items: center;
    padding: 50px 40px 12px;

    .section-label {
      font-size: 16px;
      color: #222;
      margin-right: 12px;
      white-space: nowrap;
      line-height: 40px;
    }

    .test-mode-wrap {
      display: flex;
      align-items: center;
      margin-left: 24px;
      padding: 0 16px;
      background: #fffbe6;
      border: 1px dashed #ffe58f;
      border-radius: 4px;
      height: 40px;

      .test-mode-label {
        font-size: 14px;
        color: #222;
        margin-right: 12px;
        white-space: nowrap;
      }
    }

    // 自定义高度为 40px 后，需要同步修正内部元素布局
    :deep(.ant-picker) {
      width: 433px;
      height: 40px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: 0 12px;
    }

    :deep(.ant-picker-input) {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
    }

    // ant-picker 默认高度为 34px，active-bar 默认样式基于该高度定位；
    // 当外部强制改为 40px 后，active-bar 会被底部边框遮住，
    // 因此显式贴底并提升 z-index，保证选中下划线完整显示。
    :deep(.ant-picker-active-bar) {
      bottom: 0;
      height: 2px;
      margin-left: 0;
      margin-right: 0;
      z-index: 1;
    }
  }

  .calendar-wrapper {
    margin: 0 40px;
    border: 1px solid #E6E7CF;
    border-radius: 4px;
    overflow: hidden;
    background: #EFEFD6;
  }

  .calendar-header {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 40px;
    height: 48px;
    background: #EFEFD6;

    .month-nav {
      color: #0b0b0b;
      font-size: 14px;
      padding: 0 8px;

      &:hover {
        color: #0f813d;
      }
    }

    .calendar-title {
      font-size: 16px;
      font-weight: 700;
      color: #333;
      min-width: 120px;
      text-align: center;
    }

    .today-btn {
      position: absolute;
      right: 32px;
      color: #0f813d;
      font-size: 14px;
      padding: 0 12px;

      &:hover {
        color: #0f813d;
        filter: brightness(0.8);
      }
    }
  }

  .calendar-body {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    overflow: hidden;
  }

  .calendar-weekday {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 42px;
    font-size: 14px;
    font-weight: 500;
    color: #222;
    background: #BEB7A2;

    &:nth-child(7n+1),
    &:nth-child(7n+3),
    &:nth-child(7n+5),
    &:nth-child(7n+7) {
      background: #D1D1BD;
    }
  }

  .calendar-cell {
    height: 99px;
    padding: 15px;
    background: #EFEFD6;
    border-right: 1px solid #E6E7CF;
    border-bottom: 1px solid #E6E7CF;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    position: relative;
    min-width: 0;
    overflow: hidden;

    &:nth-child(7n) {
      border-right: none;
    }

    &.empty {
      background: #EFEFD6;
      cursor: default;
      pointer-events: none;
    }

    &.out-of-range {
      background: #EFEFD6;
      cursor: pointer;
      color: #222222;

      .cell-lunar {
        color: #ADADAD;
      }

      .cell-date {
        color: #222222;
      }
    }

    &.in-range {
      background: #F6FEE6;

      &:not(.not-editable):hover {
        background: #EDF5D6;
      }
    }

    &.has-session {
      background: #F6FEE6;

      &:not(.out-of-range):not(.not-editable):hover {
        background: #EDF5D6;
      }

      &.selected:not(.not-editable) {
        background: #F2FBDC;
      }
    }

    &:not(.out-of-range):not(.has-session):not(.in-range):hover {
      background: #e8e8d8;
    }

    &.not-in-range {
      background: #EFEFD6 !important;
      cursor: pointer;
      color: #222222;

      .cell-lunar {
        color: #ADADAD;
      }

      .cell-date {
        color: #222222;
      }

      .cell-session-info {
        color: #D1D1BB;
      }

      &.has-session {
        cursor: pointer;

        .cell-session-info {
          color: #938873;
        }
      }

      &.not-editable {
        background: #EFEFD6 !important;
        color: #D1D1BB;
        cursor: pointer;

        .cell-lunar {
          color: #C0C0AC;
        }

        .cell-session-info {
          color: #D1D1BB;
        }
      }

      &.before-today .cell-date,
      &.locked-date .cell-date {
        color: #D1D1BB;
      }
    }

    &.beyond-original {
      cursor: pointer;
    }

    &.selected,
    &.selected.not-in-range,
    &.selected.not-editable,
    &.selected.not-in-range.not-editable {
      background: #F2FBDC !important;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: #319456;
      }

      .cell-date {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #319456;
        color: #fff;
        border-radius: 50%;
      }
    }

    &.not-editable {
      background: #F6FEE6;
      color: #D1D1BB;
      cursor: pointer;

      &.has-session {
        background: #F6FEE6;
      }

      .cell-lunar {
        color: #C0C0AC;
      }

      .cell-session-info {
        color: #D1D1BB;
      }

      &:not(.out-of-range):hover,
      &:not(.out-of-range).has-session:hover {
        background: #EDF5D6;
      }
    }

    &.locked-date .cell-date {
      color: #D1D1BB;
    }

    &.today:not(.selected) {
      .cell-date {
        color: #319456;
        font-weight: 700;
      }

      .cell-today-tag {
        color: #319456;
      }
    }

    .cell-content {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .cell-date {
      font-size: 18px;
      font-weight: 700;
      color: #222222;
      line-height: 24px;
      min-width: 24px;
      text-align: center;
    }

    .cell-lunar {
      font-size: 16px;
      color: #ADADAD;
      line-height: 24px;
    }

    .cell-today-tag {
      font-size: 12px;
      color: #319456;
      background: transparent;
      padding: 0;
      border-radius: 0;
      line-height: 1.4;
    }

    .cell-session-info {
      margin-top: 10px;
      padding: 0;
      background: transparent;
      border-radius: 0;
      font-size: 14px;
      font-weight: 500;
      color: #938873;
      line-height: 1.4;

      .session-time-slot {
        font-weight: 500;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 4px;
      }

      .session-count {
        font-size: 12px;
        font-weight: 500;
        opacity: 1;
      }
    }

    &.not-editable .cell-session-info {
      color: #D1D1BB;
    }
  }

  .day-session-editor {
    margin: 24px 40px 0;
    padding: 16px 0;
  }

  .editor-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;

    .editor-title {
      font-size: 16px;
      font-weight: 700;
      color: #222;
    }

    .editor-date {
      display: flex;
      align-items: center;
      width: 143px;
      height: 29px;
      background: #e0e0c8;
      border-radius: 15px;
      font-size: 13px;
      color: #222;
      padding-right: 4px;

      .editor-date-icon {
        margin-left: 12px;
        font-size: 12px;
        color: #666;
      }

      .editor-date-text {
        flex: 1;
        text-align: center;
      }
    }
  }

  .session-list {
    width: 100%;
  }

  .session-row {
    display: flex;
    align-items: center;
    gap: 0;
    padding: 0;
    margin-bottom: 12px;
    background: transparent;
    border-radius: 0;

    &.session-disabled {
      .price-input-wrap {
        background: #F6F6F6;
        border-color: #C5C5D3;

        &:hover,
        &:focus-within {
          border-color: #C5C5D3;
          box-shadow: none;
        }
      }
    }
  }

  .session-select {
    width: 156px;

    :deep(.ant-select-selector) {
      height: 40px !important;
      display: flex;
      align-items: center;
      border-radius: 4px;
    }

    :deep(.ant-input-disabled) {
      height: 40px;
      border-color: #C5C5D3;
      border-radius: 4px;
    }

    :deep(.ant-select-selector) {
      height: 40px !important;
      display: flex;
      align-items: center;
      border-radius: 4px;
    }

    :deep(.ant-select-selection-item) {
      line-height: 40px;
    }

    :deep(.ant-select-selection-placeholder) {
      line-height: 40px;
    }
  }

  .session-time {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: auto;
    margin-left: 54px;

    .label {
      color: #222;
      white-space: nowrap;
      font-size: 14px;
    }
  }

  .session-time-picker {
    display: flex;
    align-items: center;
    gap: 6px;

    :deep(.ant-picker) {
      width: 88px;
      height: 40px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      padding: 0 8px;
    }

    :deep(.ant-picker-input > input) {
      font-size: 14px;
      text-align: center;
    }
  }

  .session-price {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-left: 54px;

    .label {
      color: #222;
      white-space: nowrap;
      font-size: 14px;
    }

    .price-input-wrap {
      display: flex;
      align-items: center;
      width: 184px;
      height: 40px;
      padding: 0 8px;
      border: 1px solid #C5C5D3;
      border-radius: 4px;
      background: #fff;
      transition: border-color 0.2s;

      &:hover {
        border-color: @primary-color;
      }

      &:focus-within {
        border-color: @primary-color;
        box-shadow: 0 0 0 2px fade(@primary-color, 20%);
      }

      .price-symbol {
        color: #C5C5D3;
        font-size: 14px;
        margin-right: 4px;
        line-height: 40px;
      }

      .session-price-input {
        flex: 1;

        :deep(.ant-input),
        :deep(.ant-input-affix-wrapper) {
          border: none !important;
          box-shadow: none !important;
          background: transparent;
          height: 38px;
          padding: 0;
          text-align: left;
        }
      }
    }
  }

  .session-delete-btn {
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    padding: 0;
    border: none;
    background: #0b0b0b;
    color: #fff;
    border-radius: 50% !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    margin-left: 23px;

    :deep(.ant-btn-icon) {
      margin: 0;
    }

    :deep(.ant-btn-icon > *) {
      transform: translate(0, 0);
    }

    &>span {
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    &:hover {
      background: #0b0b0b;
      color: #fff;
    }

    &:disabled {
      background: #d9d9d9;
      color: #fff;
    }
  }

  .add-session-btn {
    color: #0f813d !important;
    padding: 0;
    height: auto;

    &:hover:not([disabled]) {
      color: #0f813d !important;
      filter: brightness(0.8);
    }

    &[disabled] {
      color: #D1D1BB !important;
    }
  }

  .detail-footer {
    display: flex;
    justify-content: center;
    padding: 80px 0 32px;

    .detail-close-btn,
    .detail-confirm-btn,
    .detail-publish-btn {
      width: 120px;
      height: 40px;
      border-radius: 20px !important;
      font-size: 16px;
    }

    .detail-close-btn,
    .detail-confirm-btn {
      border: 1px solid #0b0b0b;
      color: #0b0b0b;
      background: #fff;

      &:hover {
        color: #0b0b0b;
        border-color: #0b0b0b;
        background: #fff;
      }
    }

    .detail-confirm-btn,
    .detail-publish-btn {
      margin-left: 10px;
    }

    .detail-publish-btn {
      background: #0b0b0b;
      border-color: #0b0b0b;
      color: #fff;

      &:hover {
        background: #0b0b0b;
        border-color: #0b0b0b;
        color: #fff;
      }
    }
  }
}

:deep(.ant-picker-range) {
  .ant-picker-input {
    input::placeholder {
      text-align: center;
    }
  }
}
</style>
